import { API_URL } from '@/lib/api';

export interface GeocodeResult {
  display_name: string;
  lat: number;
  lon: number;
  place_type: string;
  importance: number;
  address: {
    city?: string;
    town?: string;
    village?: string;
    county?: string;
    state?: string;
    country?: string;
    country_code?: string;
  };
}

/**
 * Search for locations by name using the backend geocoding proxy.
 * Returns up to `limit` results sorted by relevance.
 */
export async function searchLocations(query: string, limit: number = 5): Promise<GeocodeResult[]> {
  if (!query || query.trim().length < 2) return [];

  try {
    const params = new URLSearchParams({ q: query.trim(), limit: String(limit) });
    const resp = await fetch(`${API_URL}/geocode/search?${params.toString()}`);
    if (resp.ok) {
      const data = await resp.json();
      return Array.isArray(data) ? data : [];
    }
    console.error('Geocode search failed:', resp.status);
    return [];
  } catch (err) {
    console.error('Error searching locations:', err);
    return [];
  }
}